type KeySelector<T> = ((item: T) => unknown) | string

function getPathValue(obj: any, path: string): unknown {
  return path.split(".").reduce((acc, part) => (acc == null ? undefined : acc[part]), obj)
}

/**
 * Lightweight `groupBy` replacement for lodash.
 * Supports:
 * - function iteratee: `groupBy(items, (x) => x.type)`
 * - dot-path iteratee: `groupBy(items, "product.secondaryId")`
 */
export function groupBy<T>(items: readonly T[], iteratee: KeySelector<T>): Record<string, T[]> {
  return items.reduce((acc, item) => {
    const rawKey =
      typeof iteratee === "function" ? iteratee(item) : getPathValue(item, iteratee)
    const key = String(rawKey ?? "")
    ;(acc[key] ??= []).push(item)
    return acc
  }, {} as Record<string, T[]>)
}

